import React from 'react';
import { hot } from 'react-hot-loader';
import { Provider } from 'react-redux';

import { LayoutContextProvider } from '@ott/layout-context';
import { MessageContextProvider } from '@ott/message';

import App from 'components/layouts/App';

const Root = ({ store }) => {
  return (
    <Provider store={store}>
      <LayoutContextProvider>
        <MessageContextProvider>
          <App />
        </MessageContextProvider>
      </LayoutContextProvider>
    </Provider>
  );
};

export default hot(module)(Root);
